import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { RephraseService } from './service/rephrase.service';
import { RephraseRequest } from '../../shared/models/rephraseRequest.d';
import { AlertComponent } from '../../shared/components/alert/alert.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { AlertService } from '../../shared/services/alert.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BrowserAccessService } from '../../shared/services/browser-access.service';
import { RephraseTransferService } from '../../shared/services/rephrase-transfer.service';
import { RephraseOptionsComponent } from '../rephrase-options/rephrase-options.component';
import { LanguagesService } from '../../shared/services/languages.service';

@Component({
  selector: 'app-rephrase',
  imports: [
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    AlertComponent,
    CommonModule,
    ClipboardModule,
    TranslateModule,
    RephraseOptionsComponent,
  ],
  templateUrl: './rephrase.component.html',
  styleUrls: ['./rephrase.component.scss'],
})
export class RephraseComponent implements OnInit {
  private readonly rephraseService = inject(RephraseService);
  private readonly browserCachingService = inject(BrowserAccessService);
  private readonly alertService = inject(AlertService);
  private readonly translate = inject(TranslateService);
  private readonly rephraseTransferService = inject(RephraseTransferService);
  private readonly languagesService = inject(LanguagesService);

  public rephraseLanguages = this.languagesService.rephraseLangs$;
  public selectedRephraseLanguage = '';
  public textToRephrase = '';
  public rephrasedText = '';

  ngOnInit() {
    this.CheckForDefaultRephraseLanguage();

    this.rephraseTransferService.transfer$.subscribe((payload) => {
      if (payload) {
        this.textToRephrase = payload.text;
        this.selectedRephraseLanguage = payload.language;
      }
    });
  }

  public CheckForDefaultRephraseLanguage() {
    const defaultRephraseLanguage = this.browserCachingService.getItem('defaultRephraseLanguage');
    console.log(`default rephrase language is ${defaultRephraseLanguage}`);

    if (defaultRephraseLanguage === 'undefined') {
      this.browserCachingService.removeItem('defaultRephraseLanguage');
    }
    this.selectedRephraseLanguage = defaultRephraseLanguage;
  }

  public rephraseString() {
    if (this.selectedRephraseLanguage === '' || this.textToRephrase === '') {
      this.alertService.showAlert(
        'error',
        this.translate.instant('Alert.SelectLanguageAlertMessage'),
      );
      return;
    }

    const request = {
      text: this.textToRephrase,
      targetLanguage: this.selectedRephraseLanguage,
    } as RephraseRequest;

    this.browserCachingService.setItem(
      'defaultRephraseLanguage',
      this.selectedRephraseLanguage.toString(),
    );

    this.rephraseService.rephraseText(request).subscribe({
      next: (response) => {
        if (response && response.text) {
          this.rephrasedText = response.text;
        } else {
          this.alertService.showAlert(
            'error',
            this.translate.instant('Alert.TranslateErrorMessage'),
          );
        }
      },
      error: () => {
        this.alertService.showAlert('error', this.translate.instant('Alert.TranslateErrorMessage'));
      },
    });
  }

  copyToClipboard() {
    navigator.clipboard
      .writeText(this.rephrasedText)
      .then(() => {
        this.alertService.showAlert(
          'success',
          this.translate.instant('Alert.CopiedToClipboardAlertMessage'),
        );
      })
      .catch(() => {
        this.alertService.showAlert('error', this.translate.instant('Alert.ClipboardErrorMessage'));
      });
  }
}
